/**
 * The shared launchpad Users page (`@darwin-launchpad/legacy-shared/app-settings`), as the Manage
 * dialog's Users tab and the standalone /settings/users page. Mounted only
 * after the flag and role gate have passed, so nothing is requested otherwise.
 */

import toast from 'react-hot-toast';
import { UsersSettingsPage } from '@darwin-launchpad/legacy-shared/app-settings';
import { useAuth } from '../../contexts/IframeAuthContext';
import { getUsersSettingsApi } from '../../lib/usersSettings';
import './UsersSettingsPanel.css';

export function UsersSettingsPanel() {
  const { authTenantId } = useAuth();
  const api = getUsersSettingsApi();
  if (!api) {
    return (
      <p role="alert" className="text-sm text-destructive">
        User management is not configured. Contact your administrator.
      </p>
    );
  }
  // Keyed by tenant so switching organizations reloads the member list.
  return <UsersSettingsPage key={authTenantId} api={api} notify={toast} hideHeader className="redactit-users-settings" />;
}
